import { render } from "./FrmNewWorkerRecord.vue?vue&type=template&id=a5d4eb3e"
import script from "./FrmNewWorkerRecord.vue?vue&type=script&lang=js"
export * from "./FrmNewWorkerRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__